<template>
<el-container>
  <el-header class="header flex-row flex-between" height="50px" style="background: rgba(255, 255, 255, 1);">
    <div class="logo-box flex-row flex-secondary-axis-center">
      报单管理后台
    </div>
    <div class="header-ri top">
      <el-tooltip class="d-ib v-a-middle" effect="dark" :content="isFullscreen ? '退出全屏' : '全屏'" placement="top">
        <i v-if="isFullscreen" @click="exitfullscreen" class="d-ib fullscreen"></i>
        <i v-else @click="enterfullscreen" class="d-ib fullscreen"></i>
      </el-tooltip>
      <el-avatar class="v-a-middle" :size="24" v-if="accountInfo && accountInfo.avatar" :src="accountInfo.avatar"></el-avatar>
      <el-avatar class="v-a-middle" :size="24" v-else icon="el-icon-user-solid"></el-avatar>
      <el-popover
        popper-class="login-popover"
        placement="bottom"
        width="110"
        trigger="click">
        <div class="login-popover__box">
          <!-- <p @click="resetPwdDrawer = true">修改密码</p> -->
          <p @click="logOut">退出登录</p>
        </div>
        <span slot="reference" class="v-a-middle username" style="cursor: pointer;">
          {{ accountInfo && accountInfo.nickName ? accountInfo.nickName : '用户名' }}
          <i class="el-icon-arrow-down"></i>
        </span>
      </el-popover>
    </div>
  </el-header>
  <el-container>
    <el-aside width="200px">
      <ui-menu class="menu" v-if="showMenu" :data="getMenus"></ui-menu>
    </el-aside>
    <el-main>
      <div class="wrapper flex-row">
        <section class="flex-grow-1 flex-col">
          <div class="flex-col clearfix">
            <router-view></router-view>
          </div>
        </section>
      </div>
    </el-main>
  </el-container>
</el-container>
</template>

<script>
import { baseMenuConf, baseMenuMap } from '@/conf'
import { checkPwd } from '@/utils/util'

export default {
  components: {
   },
  computed: {
    getMenus() {
      let menusConf = baseMenuConf
      return this.authDispose(menusConf)
    },
    getPageName() {
      const paths = this.getBr();
      const last = paths[ paths.length - 1 ];
      return last ? last.name : '';
    }
  },
  inject: [ 'globalStorage', 'updateGlobalStorage' ],
  data () {
    // 验证密码
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!checkPwd(value)) {
        callback(new Error('密码格式错误'))
      } else {
        callback();
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.model.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback();
      }
    }

    return {
      showMenu: true,
      roleName: [],
      isFullscreen: false, // 全屏
      accountInfo: {},
      resetPwdDrawer: false,
      model: {
        account: '',
        password: '',
        rePassword: ''
      },
      rules: {
        password: [{ validator: validatePass, trigger: 'blur' }],
        rePassword: [{ validator: validatePass2, trigger: 'blur' }]
      },
      collapsed: false,
      logo: '', // require('@/assets/images/logo-1.png'),
      messageList: [],
      showMessageDialog: false,
      accountDto: null,
      msgTotal: 0 // 消息数量
    }
  },
  beforeRouteEnter(to, from, next) {  
    if (from.path === '/login') {
      next(vm => {
        vm.showMenu = false
        setTimeout(() => {
          vm.showMenu = true
        }, 200)
      })
    }
    next()
  },
  methods: { 
    checkIsFullscreen () {
      var isFull = document.mozFullScreen||
      document.fullScreen ||
      //谷歌浏览器及Webkit内核浏览器
      document.webkitIsFullScreen ||
      document.webkitRequestFullScreen ||
      document.mozRequestFullScreen ||
      document.msFullscreenEnabled
      if(isFull === undefined) {
        isFull = false
      }
      this.isFullscreen = isFull
    },
    enterfullscreen () { // 进入全屏
      var docElm = document.documentElement;
      //W3C
      if(docElm.requestFullscreen) {
        docElm.requestFullscreen();
      }
      //FireFox
      else if(docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      }
      //Chrome等
      else if(docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      }
      //IE11
      else if(elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
      this.isFullscreen = true
    },
    exitfullscreen () { // 退出全屏
      if (this.isFullscreen) {
        if(document.exitFullscreen) {
          document.exitFullscreen();
        } else if(document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if(document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if(document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.isFullscreen = false
      }
    },
    authDispose(menus) {
      // let leaderRole = ['总经理', '项目经理']
      // if (!this.globalStorage.role || leaderRole.indexOf(this.globalStorage.role.roleName) < 0) {
      //   return menus.slice(0, -1);
      // } else {
      //   return menus;
      // }
      return menus
    },

    // 获取面包屑
    getBr() {
      let menuConf = baseMenuConf;
      let menuMap = baseMenuMap;
      // 渠道商/人资
      // menuConf = (this.accountInfo.type === 4 || this.accountInfo.type === 5) ? channelMenuConf : this.authDispose(baseMenuConf)
      menuConf = this.authDispose(baseMenuConf)

      const urls = this.$route.path.split('/');
      urls.shift();
      if (urls.length > 3) {
        if (menuMap[ this.$route.path ]) {
          return [ null, ...menuMap[ this.$route.path ] ];
        }
        return [null, null]
      } else {
        const [ , last1, last2 ] = urls;
        let paths = [];
        const item = menuConf.find(el => el.oname == last1);
        if (!item) {
          return false
        }
        if (!last2) {
          paths.push({
            url: item.url,
            name: item.name
          });
        } else {
          this.getBrs(item.children || item.child, last2, paths);
          if (paths.length) {
            if (!item.child) {
              paths = paths.slice(0, urls.length);
            }
            paths[ paths.length - 1 ].url = void 0;
          } else {
            paths.push({
              url: item.url,
              name: item.name
            });
          }
        }
        return paths;
      }
    },

    getBrs(item, val, paths) {
      if (Array.isArray(item)) {
        item.forEach(el => {
          this.getBrs(el, val, paths);
        });
      } else {
        if (item) {
          if (item.oname === val) {
            paths.push({
              url: item.url,
              name: item.name
            });
            if (item.children) {
              this.getBrs(item.children, val, paths);
            }
          }
        }
      }
    },

    // 退出登录
    logOut () {
      this.$notify({
        title: '提示',
        message: '退出成功',
        type: 'success'
      })
      localStorage.removeItem('TOKEN')
      localStorage.removeItem('ACCOUNT_DTO')
      localStorage.removeItem('AUTH_CODES')

      this.$router.push('/login')
    },

    getAccountInfo (cb) {
      let accoutDto = localStorage.getItem('ACCOUNT_DTO')
      this.accountInfo = JSON.parse(accoutDto)
      cb && cb()
    }
  },

  created() {
    let accountDto = localStorage.getItem('ACCOUNT_DTO')
    if (accountDto) {
      this.accountDto = JSON.parse(accountDto)
    }
    this.roleName = this.getRoleName()
    window.addEventListener("storage", (e) => {
      // 切换了登录用户
      if (e.key === 'LOGINNAME') {
        if ( e.oldValue !== e.newValue) {
          this.$router.replace('/login')
        }
      }
    }, false) 
    // 获取首页用户信息
    this.getAccountInfo(() => {
      this.getBr();
    })
  },
  mounted() {
    window.addEventListener('resize', this.checkIsFullscreen)
    this.checkIsFullscreen()
  },
  destroyed() {
    window.removeEventListener('resize', this.checkIsFullscreen)
  },
};
</script>

<style scoped>
  /* .wrapper {
    min-height: 100vh;
  } */
  .header {
    border-bottom: 1px solid rgba(230, 232, 240, 1);
  }
  .header-ri {
    line-height: 48px;
  }
  .top i {
    width: 12px;
    height: 12px;
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: contain;
  }
  .top i.notice {
    cursor: pointer;
    margin-right: 18px;
    background-image: url("../../../../assets/images/layout/notice_icon.png");
  }
  .top i.fullscreen {
    margin-right: 26px;
    background-image: url("../../../../assets/images/layout/fullscreen_icon.png");
    cursor: pointer;
  }
  .logo {
    display: inline-block;
    padding: 12px 0px;
    margin-right: 6px;
  }

  .logo-box {
    color: #333;
    font-size: 24px;
    font-weight: 500;
  }

  .top .left h3 {
    font-weight: 500;
    color: rgba(0, 0, 0, .85);
    font-size: 22px;
    line-height: 30px;
    margin-right: 16px;
  }
  .username {
    margin-left: 8px;
    color: #666;
    font-size: 14px;
  }
  .el-container {
    background-color: #FAFBFF;
  }
  .el-main {
    padding: 0;
    margin: 12px 16px 0 16px;
    height: calc(100vh - 62px);
  }
  .el-header {
    padding: 0 20px 0 16px;
  }

  .login-popover__box p {
    cursor: pointer;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
  .login-popover__box p:hover {
    background-color: rgba(64, 98, 255, .05);
  }
  .badge ::v-deep .el-badge__content {
    height: 12px;
    line-height: 12px;
    padding: 2px;
    transform: scale(0.8);
  }
  .badge ::v-deep .el-badge__content.is-fixed {
    top: 8px;
    right: 8px;
  }
  .wx-code {
    text-align: center;
    font-size: 16px;
    color: #888;
    line-height: 20px
  }
</style>
